import { cooperationSteps, cooperationRules } from '@/mocks/siteData';
import SectionHeading from '@/components/base/SectionHeading';

export default function CooperationFlow() {
  return (
    <section className="bg-background-50 py-14 md:py-24">
      <div className="w-full px-5 md:px-8 lg:px-12">
        <div className="max-w-[1400px] mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14">
          <div className="lg:col-span-7">
            <SectionHeading
              kicker="Process"
              title="合作从这里开始"
              description="从提交申请到正式启动，通常需要一到两周。复杂的联合调查会涉及更多轮沟通。"
            />

            <ol className="mt-10 space-y-8">
              {cooperationSteps.map((step, index) => (
                <li key={step.step} className="relative flex items-start gap-5">
                  <div className="flex flex-col items-center">
                    <span className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-500 font-mono text-sm text-background-50">
                      {step.step}
                    </span>
                    {index < cooperationSteps.length - 1 ? (
                      <span className="w-px flex-1 min-h-[36px] bg-foreground-950/15 mt-2"></span>
                    ) : null}
                  </div>
                  <div className="pt-1">
                    <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950">
                      {step.title}
                    </h3>
                    <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                      {step.desc}
                    </p>
                  </div>
                </li>
              ))}
            </ol>
          </div>

          <div className="lg:col-span-5">
            <div className="bg-foreground-950 text-background-100 rounded-lg p-6 md:p-8 lg:sticky lg:top-28">
              <p className="font-mono text-xs tracking-[0.3em] uppercase text-accent-400">
                Boundaries
              </p>
              <h3 className="mt-4 font-heading text-xl md:text-2xl font-bold text-background-50">
                合作的四条边界
              </h3>
              <ul className="mt-7 space-y-5">
                {cooperationRules.map((rule) => (
                  <li key={rule} className="flex items-start gap-3.5">
                    <i className="ri-subtract-line text-accent-400 mt-1 shrink-0"></i>
                    <p className="text-sm leading-relaxed text-background-200">{rule}</p>
                  </li>
                ))}
              </ul>
              <p className="mt-8 pt-6 border-t border-background-50/15 text-xs leading-relaxed text-background-400">
                以上边界适用于全部合作类型，不接受个别议价。请在申请前确认可以接受。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}